import deepmerge from 'deepmerge'
import frenchMessages from 'ra-language-french'

import fr from './fr.json'

export default deepmerge.all([frenchMessages, fr])
